import React from 'react';
import { BiLogoTypescript } from "react-icons/bi";
import { BiLogoJavascript } from "react-icons/bi";
import { BiLogoReact } from "react-icons/bi";
import { BiLogoPython } from "react-icons/bi";
import { BiLogoDjango } from "react-icons/bi";
import { BiLogoCPlusPlus } from "react-icons/bi";
import { MdHtml } from "react-icons/md";
import { MdCss } from "react-icons/md";
import { BiLogoTailwindCss } from "react-icons/bi";
import { FaNode } from "react-icons/fa";
import { FaFigma } from "react-icons/fa6";
import { VscVscodeInsiders } from "react-icons/vsc";
import { AiOutlineLinux } from "react-icons/ai";
import { SiMacos } from "react-icons/si";
import { Si42 } from "react-icons/si";
import { BiLogoGit } from "react-icons/bi";
import { DiNginx } from "react-icons/di";
import { IoLogoDocker } from "react-icons/io5";
import { SiExpress } from "react-icons/si";
import { TbApi } from "react-icons/tb";
import { SiOdoo } from "react-icons/si";
import { RiNextjsFill } from "react-icons/ri";


interface ExpertiseCardProps {
  framworkName: string;
}

const iconMap: { [key: string]: React.ComponentType<{ className?: string }> } = {
  typescript: BiLogoTypescript,
  javascript: BiLogoJavascript,
  react: BiLogoReact,
  python: BiLogoPython,
  django: BiLogoDjango,
  cplusplus: BiLogoCPlusPlus,
  html: MdHtml,
  css: MdCss,
  tailwindcss: BiLogoTailwindCss,
  node: FaNode,
  figma: FaFigma,
  vscode: VscVscodeInsiders,
  linux: AiOutlineLinux,
  macos: SiMacos,
  fortyTwo: Si42,
  git: BiLogoGit,
  nginx: DiNginx,
  docker: IoLogoDocker,
  express: SiExpress,
  api: TbApi,
  odoo: SiOdoo,
  nextjs: RiNextjsFill,
};

const ExpertiseCard: React.FC<ExpertiseCardProps> = ({ framworkName }) => {
  const IconComponent = iconMap[framworkName.toLowerCase()];

  return (
    <div className="bg-opacity-15 hover:bg-opacity-25 bg-white text-white rounded-lg shadow-md min-h-[100px] min-w-[100px] flex items-center justify-center backdrop-blur">
      {IconComponent ? (
        <IconComponent className="text-[50px] hover:text-customGreen transition" />
      ) : (
        <div className="text-center text-[20px]">Icon not found</div>
      )}
    </div>
  );
};

export default ExpertiseCard;
